import "bootstrap-vue/dist/bootstrap-vue.css";
import "vue-multiselect/dist/vue-multiselect.min.css";
import "@fortawesome/fontawesome-free/css/all.css";
import "./assets/styles/theme/index.scss";
import "./assets/styles/app.scss";
import "./assets/styles/bootstrap/index.scss";
import "./assets/styles/bootstrap-dark/index.scss";

import Vue from "vue";

import { restClient } from "./ajax";
import App from "./App.vue";
import { getAccessToken } from "./authentication";
import { msalInstance } from "./authentication/msalInstance";
import configure from "./config";
import router, { routeNames, routePaths } from "./router";
import store, { AppActionTypes } from "./store";

// Handle redirect flow when the app loads
msalInstance.initialize().then(() => {
    msalInstance.handleRedirectPromise().then(async (response) => {
        // Use the token from the redirect response, or acquire one silently
        // (e.g., on a page refresh when the user already has an active session).
        // getAccessToken() uses MSAL's acquireTokenSilent which automatically refreshes
        // expired tokens via the refresh token, and redirects to login only when needed.
        const token = response?.accessToken ?? (await getAccessToken());

        if (token) {
            restClient.setAuthorizationHeader(token);

            configure();

            store.dispatch(AppActionTypes.getSettings).then(async () => {
                new Vue({
                    store: store,
                    router: router,
                    provide: {
                        routeNames,
                        routePaths,
                        restClient,
                        msal: msalInstance
                    },
                    render: (h) => h(App)
                }).$mount("#app");
            });
        }
        // Note: getAccessToken() handles redirecting to login when a session cannot be obtained
    });
});
